import api from '@/utils/api';
import {
    GET_LIST_INTERACTION_STATUS,
    GET_SPECIFIC_INTERACTION_STATUS,
    UPDATE_SPECIFIC_INTERACTION_STATUS,
    CREATE_NEW_INTERACTION_STATUS,
    REMOVE_INTERACTION_STATUS,
    GET_INTERACTION_STATUS_ACTIVE
} from './types';
import { NotificationManager } from 'react-notifications';

export const getListInteractionStatus = (filter) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get('/interaction-statuses', { params: filter }).then(res => {
            dispatch({ type: GET_LIST_INTERACTION_STATUS, payload: res.data.data });
            resolve(res.data);
        }).catch(err => {
            console.log(err)
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}

export const getSpecificInteractionStatus = (id) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get(`/interaction-statuses/${id}`).then(res => {
            dispatch({ type: GET_SPECIFIC_INTERACTION_STATUS, payload: res.data.data });
            resolve(res.data.data);
        }).catch(err => {
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}

export const getInteractionStatusActive = (filter) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get('/interaction-statuses/by-active', { params: filter }).then(res => {
            //console.log(res)
            dispatch({ type: GET_INTERACTION_STATUS_ACTIVE, payload: res.data });
            resolve(res.data);
        }).catch(err => {
            console.log(err)
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}

export const createInteractionStatus = (data) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.post('/interaction-statuses', data).then(res => {
            dispatch({ type: CREATE_NEW_INTERACTION_STATUS, payload: res.data.data });
            NotificationManager.success("Thêm mới bản ghi thành công!");
            resolve(res.data.data);
        }).catch(err => {
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}



export const updateInteractionStatus = (id, data) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.put(`/interaction-statuses/${id}`, data).then(res => {
            dispatch({ type: UPDATE_SPECIFIC_INTERACTION_STATUS, payload: res.data.data });
            NotificationManager.success("Cập nhật bản ghi thành công!");
            resolve(res.data);
        }).catch(err => {
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}

export const removeInteractionStatus = (ids) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.delete(`/interaction-statuses`, { data: { ids: ids } }).then(res => {
            dispatch({ type: REMOVE_INTERACTION_STATUS, payload: ids });
            NotificationManager.success("Xoá bản ghi thành công!");
            resolve(res.data);
        }).catch(err => {
            console.log(err)
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}
